/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LocationMainDto model module.
 * @module model/LocationMainDto
 * @version v1.0.0
 */
class LocationMainDto {
    /**
     * Constructs a new <code>LocationMainDto</code>.
     * @alias module:model/LocationMainDto
     */
    constructor() { 
        
        LocationMainDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LocationMainDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LocationMainDto} obj Optional instance to populate.
     * @return {module:model/LocationMainDto} The populated <code>LocationMainDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LocationMainDto();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} code
 */
LocationMainDto.prototype['code'] = undefined;

/**
 * @member {String} id
 */
LocationMainDto.prototype['id'] = undefined;

/**
 * @member {String} name
 */
LocationMainDto.prototype['name'] = undefined;

/**
 * @member {Number} seq
 */
LocationMainDto.prototype['seq'] = undefined;






export default LocationMainDto;

